import { createAsyncThunk } from "@reduxjs/toolkit";

import { environment } from "../../environments";
import {
  GetIconsLibraryJSONRequest,
  GetIconsLibraryJSONResponse,
  GetIconsRequest,
  GetIconsResponse,
} from "../../models/Icon.model";

const API_BASE_URL = environment.apiUrl;

export const GetIcons = createAsyncThunk<
  GetIconsResponse,
  GetIconsRequest,
  { rejectValue: string }
>("icon/GetIcons", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}Icon/GetIcons`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: GetIconsResponse = await response.json();

    if (!data.success)
      return rejectWithValue(data.message || "Failed to fetch base tables");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error",
    );
  }
});

export const GetIconsLibrary = createAsyncThunk<
  GetIconsLibraryJSONResponse,
  GetIconsLibraryJSONRequest,
  { rejectValue: string }
>("icon/GetIconsLibrary", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}Icon/GetIconsLibrary`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: GetIconsLibraryJSONResponse = await response.json();

    if (!data.success)
      return rejectWithValue(data.message || "Failed to fetch base tables");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error",
    );
  }
});
